<template>
  <transition name="modal-fade">
    <div class="gd-modal-backdrop" @click.stop>
      <div
        class="modal fade show overflow-auto"
        style="display: block"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <div
          class="modal-dialog gd-modal-dialog-centered"
          :class="modalIsLarge === true ? 'modal-lg' : ''"
          style="cursor: default;"
          @click.stop
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <slot name="title">
                <h5 class="modal-title">Modal Title</h5>
              </slot>
              <button
                type="button"
                class="close"
                @click="close"
                aria-label="Close modal"
              >
                <span aria-hidden="true">
                  <x-icon size="1x" class="custom-class"></x-icon>
                </span>
              </button>
            </div>
            <div class="modal-body">
              <slot name="body">
                I'm the default body!
              </slot>
            </div>
            <div class="modal-footer" v-if="footer">
              <slot name="footer">
                I'm default footer
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { XIcon } from "vue-feather-icons";
export default {
  name: "modal",
  props: {
    footer: Boolean,
    modalIsLarge: Boolean
  },
  components: {
    XIcon
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.gd-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  transition: opacity 0.3s ease;
  z-index: 9998;
  justify-content: center;
  align-items: center;
}

.gd-modal-dialog-centered {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  min-height: 0;
}

@media (max-width: 600px) {
  .gd-modal-dialog-centered {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    min-height: calc(100% - 1rem);
  }
}
</style>
